
import { format } from 'date-fns'

export default {
  props: {
    data: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      reviewSwiperOptions: {
        slidesPerView: 1,
        speed: 500,
        loop: true,
        pagination: {
          el: '.review-swiper-pagination',
          clickable: true,
        },

        navigation: {
          nextEl: '.review-swiper-btn-next',
        },
      },
    }
  },

  methods: {
    formatDate(date) {
      return format(new Date(date), 'dd.MM.yyyy')
    },
  },
}
